// Trading strategies — RE₿EL LLM pipeline translation (Sprint B).
// tipo/nivel keys preserved from ES for cross-locale filter/color consistency.

export const ESTRATEGIAS = [
  {
    id: "smc-order-block",
    nombre: "SMC — Einstieg im Order Block",
    tipo: "tendencia",
    mercados: [
      "BTC",
      "ETH",
      "Altcoins"
    ],
    timeframes: [
      "1H",
      "4H",
      "D"
    ],
    dificultad: "intermedia",
    winRate: "55-65%",
    ratioRR: "1:3 — 1:5",
    descripcion: "Institutioneller Einstieg in Order Block-Zonen nach einem Break of Structure (BOS). Dies ist die Kernstrategie von Smart Money Concepts. Man wartet darauf, dass der Preis die Zone erneut testet, in der institutionelle Akteure ihre Orders platziert haben, um gemeinsam mit ihnen einzusteigen.",
    condicionesEntrada: [
      "1. Trend im höheren Zeitrahmen identifizieren (D oder 4H).",
      "2. Auf einen Break of Structure (BOS) in Trendrichtung warten.",
      "3. Den Order Block identifizieren, der den BOS verursacht hat (letzte entgegengesetzte Kerze vor dem Impuls).",
      "4. Warten, bis der Preis in den Bereich des Order Blocks zurückkehrt (Rücksetzer).",
      "5. Mit Struktur im niedrigeren Zeitrahmen bestätigen (1H oder 15m): bullischer CHoCH im OB.",
      "6. In der oberen Hälfte des OB einsteigen (Discount-Zone innerhalb des OB)."
    ],
    stopLoss: "Unterhalb des Tiefs des Order Blocks (mit kleinem Puffer von 0,5%).",
    takeProfit: "Nächste Liquiditätszone / vorheriges Hoch / Fibonacci-Extension 161,8%.",
    ejemploReal: "BTC zeigt im 4H bullischen BOS mit Durchbruch von 44.000. Der bullische OB liegt zwischen 42.800-43.200 (letzte rote Kerze vor dem Impuls). Preis kehrt zu 43.000 zurück, im 1H bildet sich bullischer CHoCH. Einstieg bei 43.100, SL bei 42.700, TP bei 45.500. R:R ≈ 1:3.",
    erroresComunes: [
      "In den OB einsteigen, ohne auf Bestätigung im niedrigeren Zeitrahmen zu warten.",
      "Den Trend des höheren Zeitrahmens nicht korrekt identifizieren.",
      "Den SL zu eng innerhalb des OB setzen — der Preis kann ihn auslösen.",
      "Den OB mit einer zufälligen Konsolidierungszone verwechseln."
    ],
    consejosPro: [
      "OBs mit FVG darüber sind stärker — doppelte institutionelle Konfluenz.",
      "Der gültigste OB ist derjenige, der den jüngsten BOS verursacht hat.",
      "OBs ignorieren, die mehr als zweimal getestet wurden.",
      "Mit Liquidität kombinieren: einsteigen, wenn der Preis zuerst Stops jagt und dann zum OB zurückkehrt."
    ]
  },
  {
    id: "fvg-fill",
    nombre: "FVG Fill — Auffüllen von Ineffizienzen",
    tipo: "reversion",
    mercados: [
      "BTC",
      "ETH",
      "Todos"
    ],
    timeframes: [
      "15m",
      "1H",
      "4H"
    ],
    dificultad: "basica",
    winRate: "60-70%",
    ratioRR: "1:2 — 1:3",
    descripcion: "Der Preis tendiert dazu, Fair Value Gaps (FVG) aufzufüllen, die durch heftige Impulse entstanden sind. Diese Strategie nutzt die Tendenz des Marktes, das Preisgleichgewicht zu suchen. Einfach und mit hoher Wahrscheinlichkeit, wenn in Konfluenz mit Struktur verwendet.",
    condicionesEntrada: [
      "1. Einen starken Impuls (bullisch oder bärisch) mit sichtbarem FVG identifizieren.",
      "2. Der FVG ist der Raum zwischen dem oberen Docht von Kerze 1 und dem unteren Docht von Kerze 3.",
      "3. Warten, bis der Preis zum FVG zurückkehrt.",
      "4. Besser, wenn der FVG mit einem Order Block oder Unterstützungs-/Widerstandszone zusammenfällt.",
      "5. Bei 50% des FVG einsteigen (Mitte des Gaps).",
      "6. Mit Ablehnungskerze oder Struktur im niedrigeren TF bestätigen."
    ],
    stopLoss: "Unterhalb des gesamten FVG (wenn der Preis ihn komplett durchquert, ist der FVG nicht mehr gültig).",
    takeProfit: "Das Extrem, von dem aus der FVG entstand — der ursprüngliche Impuls.",
    ejemploReal: "ETH bullischer Impuls von 2.200 auf 2.450. FVG zwischen 2.280-2.320. Preis kehrt zu 2.300 zurück, Doji-Kerze der Unentschlossenheit. Einstieg bei 2.300, SL bei 2.270, TP bei 2.420. R:R ≈ 1:4.",
    erroresComunes: [
      "In FVGs einsteigen, die bereits aufgefüllt wurden — ein gefüllter FVG verliert seinen Magnetismus.",
      "Den Makrotrend ignorieren — FVGs gegen den Trend zu handeln hat geringere Wahrscheinlichkeit.",
      "Sehr kleine FVGs (<0,5%) haben geringere statistische Zuverlässigkeit."
    ],
    consejosPro: [
      "FVGs in Konfluenz mit Order Blocks sind am stärksten.",
      "Ein zur Hälfte (50%) gefüllter und abgelehnter FVG ist ein sehr starkes Signal.",
      "Im Aufwärtstrend nur bullische FVGs handeln. Nicht gegen den Trend kämpfen.",
      "FVGs bei Sitzungseröffnung (London, NY) haben hohe Auffüllrate."
    ]
  },
  {
    id: "wyckoff-accumulation",
    nombre: "Wyckoff — Einstieg in der Akkumulation",
    tipo: "reversion",
    mercados: [
      "BTC",
      "ETH"
    ],
    timeframes: [
      "4H",
      "D",
      "W"
    ],
    dificultad: "avanzada",
    winRate: "50-60%",
    ratioRR: "1:5 — 1:10",
    descripcion: "Richard Wyckoff entwickelte in den 1930er Jahren eine Methode, um zu verstehen, wie institutionelle Händler Positionen akkumulieren und verteilen. Die Akkumulationsphase ist der Zeitraum, in dem die Großen still kaufen, bevor der große Anstieg kommt. Sie korrekt zu identifizieren bietet die besten R:R des Marktes.",
    condicionesEntrada: [
      "1. Preliminary Support (PS): erste Erholung nach starkem Fall — erstes Zeichen von Käuferinteresse.",
      "2. Selling Climax (SC): extreme bärische Kerze mit sehr hohem Volumen — Verkaufspanik.",
      "3. Automatic Rally (AR): starke Erholung vom SC — definiert die Obergrenze der Range.",
      "4. Secondary Test (ST): kehrt zum SC-Niveau zurück, aber mit geringerem Volumen — Bestätigung.",
      "5. Creek (Widerstand): der Preis oszilliert in der Range, bildet Hochs und Tiefs.",
      "6. Jump Across the Creek (JAC): klarer Ausbruch mit Volumen über die Obergrenze der Range.",
      "7. Back Up to the Creek (BU): Retest des Ausbruchs — letzte Einstiegsgelegenheit.",
      "8. Einstieg im BU mit SL unter der Akkumulationsrange."
    ],
    stopLoss: "Tagesschlusskurs unterhalb der Akkumulationsrange (Selling Climax).",
    takeProfit: "Projektion der Höhe der Akkumulationsrange × 2-3 ab dem Ausbruch.",
    ejemploReal: "BTC im Jahr 2020: Akkumulationsrange 6.000-12.000. SC im März 2020 (~4.000). AR bei 10.000. Range 6K-12K über 6 Monate. JAC im Oktober 2020. BU bei 12.000. Einstieg 12.500, SL 9.000, TP-Ziel 30.000+. Tatsächliches R:R: 1:10+.",
    erroresComunes: [
      "Akkumulationen identifizieren, wo nur Distribution ist — Phasen verwechseln.",
      "Vor dem JAC einsteigen — die Range kann Wochen oder Monate dauern.",
      "Nicht auf den BU warten — beim JAC einsteigen mit geringerem R:R."
    ],
    consejosPro: [
      "Volumen ist bei Wyckoff entscheidend — ohne Volumen keine Bestätigung.",
      "Längere Akkumulationsranges (3-6 Monate) erzeugen die besten Bewegungen.",
      "BTC im Wochenchart zeigt Wyckoff sehr klar in 2019-2020 und 2022-2023.",
      "Mit On-Chain kombinieren: Wyckoff-Akkumulation + Exchange Outflow = sehr starkes Signal."
    ]
  },
  {
    id: "breakout-retest",
    nombre: "Breakout + Retest von Widerstand",
    tipo: "ruptura",
    mercados: [
      "Todos"
    ],
    timeframes: [
      "1H",
      "4H",
      "D"
    ],
    dificultad: "basica",
    winRate: "55-65%",
    ratioRR: "1:2 — 1:4",
    descripcion: "Eine der klassischsten und effektivsten Strategien. Der Preis durchbricht einen wichtigen Widerstand mit Volumen, kehrt zurück, um dieses Niveau zu testen (jetzt Unterstützung) und bietet einen risikoarmen Einstieg mit dem Trend. Der Retest bestätigt, dass die alte Decke der neue Boden ist.",
    condicionesEntrada: [
      "1. Einen klar definierten Widerstand identifizieren (mindestens 2-3 vorherige Berührungen).",
      "2. Auf Ausbruch mit KLAREM Schlusskurs über dem Widerstand warten.",
      "3. Mit überdurchschnittlichem Volumen in der Ausbruchskerze bestätigen.",
      "4. Auf den Retest warten — der Preis kehrt zurück, um die gebrochene Linie zu berühren.",
      "5. Beim Retest nach Ablehnungskerze suchen (Doji, Hammer, Engulfing) auf dem Niveau.",
      "6. Einstieg beim Schluss der Bestätigungskerze des Retests."
    ],
    stopLoss: "Unterhalb des Tiefs der Retest-Bestätigungskerze (oder unter dem gebrochenen Widerstand).",
    takeProfit: "Projektion der Höhe der vorherigen Range ab dem Ausbruchsniveau.",
    ejemploReal: "BTC Widerstand bei 48.000 mit 4 Berührungen in 2 Monaten. Ausbruch mit Tageskerze, die bei 49.500 mit Volumen x2 schließt. Retest bei 48.200, Hammer-Bestätigung. Einstieg 48.500, SL 47.200, TP 54.000. R:R ≈ 1:4.",
    erroresComunes: [
      "BEIM Ausbruch einsteigen, ohne auf den Retest zu warten — hohes Risiko eines falschen Ausbruchs.",
      "Der Retest erreicht nicht immer das exakte Niveau — Spielraum von ±1-2% geben.",
      "Ausbrüche ohne Volumen haben hohe Fehlerrate."
    ],
    consejosPro: [
      "Der ideale Retest berührt das Niveau mit geringerem Volumen als der Ausbruch.",
      "Wenn der Retest deutlich unter das Niveau fällt, wird das Setup ungültig.",
      "Mit EMA200 oder einem Order Block als zusätzliche Konfluenz kombinieren.",
      "In Krypto sind Ausbrüche von Allzeithochs (ATH) besonders stark."
    ]
  },
  {
    id: "london-breakout",
    nombre: "London Open Breakout",
    tipo: "ruptura",
    mercados: [
      "BTC",
      "ETH"
    ],
    timeframes: [
      "15m",
      "1H"
    ],
    dificultad: "basica",
    winRate: "55-60%",
    ratioRR: "1:2 — 1:3",
    descripcion: "Die Londoner Handelssitzung (7:00-10:00 CET) ist neben der New Yorker Eröffnung die volatilste im Kryptomarkt. Europäische institutionelle Anleger betreten den Markt und erzeugen direkte Bewegungen. Der Preis durchbricht in der Regel die während der asiatischen Nacht gebildete Range.",
    condicionesEntrada: [
      "1. Identifizieren Sie die Range der asiatischen Sitzung (00:00-07:00 CET): Höchst- und Tiefstwert.",
      "2. Markieren Sie diese Niveaus im 15-Minuten-Chart.",
      "3. Ab 07:00 CET auf den Ausbruch aus der asiatischen Range warten.",
      "4. Einstieg beim Schlusskurs der ersten 15m-Kerze, die die Range klar durchbricht.",
      "5. Alternative: Auf Mikro-Retest der durchbrochenen Range im 5-Minuten-Chart warten."
    ],
    stopLoss: "Am entgegengesetzten Ende der asiatischen Range.",
    takeProfit: "Projektion der Höhe der asiatischen Range vom Ausbruchspunkt aus.",
    ejemploReal: "BTC in Range 43.500-44.200 während der Nacht. Um 7:15 CET schließt 15m-Kerze bei 44.350. Einstieg 44.350, SL 43.500, TP 44.900.",
    erroresComunes: [
      "Den London Breakout gegen den 4H-Trend handeln.",
      "Tage mit wichtigen makroökonomischen Ereignissen: diese Strategie nicht verwenden.",
      "Sehr enge asiatische Range (<0,5%) ergibt schlechtes R:R-Verhältnis."
    ],
    consejosPro: [
      "Funktioniert am besten, wenn die asiatische Range die ganze Nacht ohne Fakeouts anhält.",
      "Mit makroökonomischer Ausrichtung des Tages kombinieren: Wenn der Markt im Aufwärtstrend ist, nur Ausbrüche nach oben.",
      "Montags und dienstags haben statistisch die saubersten London Breakouts."
    ]
  }
];

export const ESTRATEGIA_TIPOS = [
  {
    id: "todas",
    label: "Alle"
  },
  {
    id: "tendencia",
    label: "Trend"
  },
  {
    id: "reversion",
    label: "Umkehr"
  },
  {
    id: "ruptura",
    label: "Ausbruch"
  },
  {
    id: "rango",
    label: "Range"
  },
  {
    id: "scalping",
    label: "Scalping"
  }
];

export const ESTRATEGIA_NIVELES = [
  {
    id: "todas",
    label: "Alle"
  },
  {
    id: "basica",
    label: "Grundlegend"
  },
  {
    id: "intermedia",
    label: "Fortgeschritten"
  },
  {
    id: "avanzada",
    label: "Erweitert"
  }
];
